import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoomV2 from "./components/V2/Room/RoomV2";
import ChatHistoryV2 from "./components/V2/IconSidebar_ChatHistory/ChatHistoryV2";
import "./App.css";
import "./styles/facemeet-theme.css";
import { ToastViewport, Spinner } from "./styles/facemeet-ui";  // Phase 2
import HomeV2 from "./components/V2/Home_Join_Login/HomeV2";
import LoginPageV2 from "./components/V2/Home_Join_Login/LoginPageV2";
import JoinPageV2 from "./components/V2/Home_Join_Login/JoinPageV2";
import PricingPageV2 from "./components/V2/Home_Join_Login/PricingPageV2";

import AdminErrorBoundary from
  "./components/V2/SuperAdmin/shared/AdminErrorBoundary";

const AdminLoginV2 = React.lazy(() =>
  import(/* webpackChunkName: "admin" */
    "./components/V2/SuperAdmin/AdminLayout/AdminLoginV2"));

const AdminAuthGuard = React.lazy(() =>
  import(/* webpackChunkName: "admin" */
    "./components/V2/SuperAdmin/shared/AdminAuthGuard"));

const AdminLayoutV2 = React.lazy(() =>
  import(/* webpackChunkName: "admin" */
    "./components/V2/SuperAdmin/AdminLayout/AdminLayoutV2"));

    function AdminChunkLoader() {
      return (
        <div className="fm-admin-guard-loading" role="status" aria-live="polite">
          <Spinner size="lg" />
          <p>Loading admin…</p>
        </div>
      );
    }
    
function App() {
  return (
    <Router>
      <div className="App">
        <ToastViewport />
        <Routes>
          <Route path="/v2/login" element={<LoginPageV2 />} />
          <Route path="/v2" element={<HomeV2 />} />
          <Route path="/v2/room/:roomId" element={<RoomV2 />} />
          <Route path="/v2/chat-history/:roomId" element={<ChatHistoryV2 />} />
          <Route path="/v2/join/:meetingId" element={<JoinPageV2 />} />
          <Route path="/v2/pricing" element={<PricingPageV2 />} />

          {/* ── Admin routes (Step 4) ─────────────────────────── */}
          {/* Public — anyone can reach this URL; the page itself bounces
              already-signed-in admins. */}
          <Route
            path="/admin/login"
            element={
              <AdminErrorBoundary>
                <Suspense fallback={<AdminChunkLoader />}>
                  <AdminLoginV2 />
                </Suspense>
              </AdminErrorBoundary>
            }
          />

          {/* Protected — AdminAuthGuard validates the session and
              redirects to /admin/login if invalid. AdminLayoutV2 owns
              all the nested module routes. */}
          <Route
            path="/admin/*"
            element={
              <AdminErrorBoundary>
                <Suspense fallback={<AdminChunkLoader />}>
                  <AdminAuthGuard>
                    <AdminLayoutV2 />
                  </AdminAuthGuard>
                </Suspense>
              </AdminErrorBoundary>
            }
          />
        </Routes>
    
      </div>
      
    </Router>
  );
}

export default App;
